import styled from '../../../theme'

const CursorPointer = styled.div`
  cursor: pointer;
  * {
    cursor: pointer;
  }
`

export default CursorPointer
